import React from 'react';
import { SVGAttributes } from 'react';

export const ClipboardColoredIcon: React.FC<SVGAttributes<never>> = (props) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="clipboard 1">
        <path
          id="Vector"
          d="M7.40493 49.1068C7.40493 36.8099 1.03516 28.3654 1.03516 22.4401C1.03516 16.5148 4.44138 4.07031 31.7 4.07031C58.9587 4.07031 62.9587 20.8116 62.9587 27.329C62.9605 57.8481 7.40493 70.8845 7.40493 49.1068Z"
          fill="#EFEFEF"
        />
        <path
          id="Vector_2"
          d="M6.22135 10.6654C4.75113 10.6654 3.55469 9.46892 3.55469 7.9987C3.55469 6.52848 4.75113 5.33203 6.22135 5.33203C7.69158 5.33203 8.88802 6.52848 8.88802 7.9987C8.88802 9.46892 7.69158 10.6654 6.22135 10.6654ZM6.22135 7.10981C5.73247 7.10981 5.33247 7.50803 5.33247 7.9987C5.33247 8.48936 5.73247 8.88759 6.22135 8.88759C6.71024 8.88759 7.11024 8.48936 7.11024 7.9987C7.11024 7.50803 6.71024 7.10981 6.22135 7.10981Z"
          fill="#FF7575"
        />
        <path
          id="Vector_3"
          d="M20.8915 17.332C18.927 17.332 17.3359 18.9231 17.3359 20.8876V48.4431C17.3359 50.4076 18.927 51.9987 20.8915 51.9987H43.1137C45.0782 51.9987 46.6693 50.4076 46.6693 48.4431V20.8876C46.6693 18.9231 45.0782 17.332 43.1137 17.332H20.8915Z"
          fill="#F3F3F1"
        />
        <path
          id="Vector_4"
          d="M39.5564 15.5556V19.1111C39.5564 20.0924 38.76 20.8889 37.7786 20.8889H26.2231C25.2418 20.8889 24.4453 20.0924 24.4453 19.1111V15.5556H28.4453C28.4453 13.6 30.0453 12 32.0009 12C33.9564 12 35.5564 13.6 35.5564 15.5556H39.5564Z"
          fill="#FF7575"
        />
        <path
          id="Vector_5"
          d="M21.3359 48.4431V20.8876C21.3359 18.9231 22.927 17.332 24.8915 17.332H20.8915C18.927 17.332 17.3359 18.9231 17.3359 20.8876V48.4431C17.3359 50.4076 18.927 51.9987 20.8915 51.9987H24.8915C22.927 51.9987 21.3359 50.4076 21.3359 48.4431Z"
          fill="#D5DBE1"
        />
        <g id="Group">
          <path
            id="Vector_6"
            d="M33.997 12.6222C33.4263 12.2311 32.7383 12 31.997 12C30.0414 12 28.4414 13.6 28.4414 15.5556H32.4414C32.4414 14.3413 33.0601 13.264 33.997 12.6222Z"
            fill="#DE5761"
          />
          <path
            id="Vector_7"
            d="M28.4414 19.1122V15.5566H24.4414V19.1122C24.4414 20.0935 25.2379 20.89 26.2192 20.89H30.2192C29.2379 20.89 28.4414 20.0935 28.4414 19.1122Z"
            fill="#DE5761"
          />
        </g>
        <path
          id="Vector_8"
          d="M43.1111 53.3333H20.8889C18.192 53.3333 16 51.1413 16 48.4444V20.8889C16 18.192 18.192 16 20.8889 16H24.2364V18.6667H20.8889C19.664 18.6667 18.6667 19.664 18.6667 20.8889V48.4444C18.6667 49.6693 19.664 50.6667 20.8889 50.6667H43.1111C44.336 50.6667 45.3333 49.6693 45.3333 48.4444V20.8889C45.3333 19.664 44.336 18.6667 43.1111 18.6667H39.7636V16H43.1111C45.808 16 48 18.192 48 20.8889V48.4444C48 51.1413 45.808 53.3333 43.1111 53.3333Z"
          fill="black"
        />
        <path
          id="Vector_9"
          d="M37.7799 22.2235H26.2244C24.5088 22.2235 23.1133 20.828 23.1133 19.1124V15.5569C23.1133 14.8209 23.7106 14.2235 24.4466 14.2235H27.2982C27.8813 12.1737 29.7693 10.668 32.0022 10.668C34.2351 10.668 36.1231 12.1737 36.7062 14.2235H39.5577C40.2937 14.2235 40.8911 14.8209 40.8911 15.5569V19.1124C40.8911 20.828 39.4955 22.2235 37.7799 22.2235ZM25.7799 16.8902V19.1124C25.7799 19.3577 25.9791 19.5569 26.2244 19.5569H37.7799C38.0253 19.5569 38.2244 19.3577 38.2244 19.1124V16.8902H35.5577C34.8217 16.8902 34.2244 16.2929 34.2244 15.5569C34.2244 14.332 33.2271 13.3346 32.0022 13.3346C30.7773 13.3346 29.7799 14.332 29.7799 15.5569C29.7799 16.2929 29.1826 16.8902 28.4466 16.8902H25.7799Z"
          fill="black"
        />
        <path
          id="Vector_10"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.7631 30.4487C28.7631 27.611 31.0184 25.3105 33.8004 25.3105C34.2138 25.3105 34.6154 25.3613 34.9998 25.4571C32.7968 26.0059 31.1618 28.0326 31.1618 30.4487C31.1618 32.8647 32.7968 34.8914 34.9998 35.4402C34.6154 35.536 34.2138 35.5868 33.8004 35.5868C31.0184 35.5868 28.7631 33.2864 28.7631 30.4487ZM24.4453 40.5566C24.4453 39.9566 24.77 39.4056 25.2895 39.124C28.3141 37.4845 31.6803 36.7769 34.9998 37.0011C32.479 37.1713 29.9852 37.879 27.6882 39.124C27.1687 39.4056 26.8441 39.9566 26.8441 40.5566V44.1502C26.8441 45.0961 27.5958 45.8629 28.5232 45.8629H26.1244C25.1971 45.8629 24.4453 45.0961 24.4453 44.1502L24.4453 40.5566Z"
          fill="#D6DBE1"
        />
        <path
          id="Vector_11"
          d="M28.6661 30.4487C28.6661 28.5594 30.1662 27.0366 32.0061 27.0366C33.846 27.0366 35.3462 28.5594 35.3462 30.4487C35.3462 32.3379 33.846 33.8607 32.0061 33.8607C30.1662 33.8607 28.6661 32.3379 28.6661 30.4487ZM32.0061 25.0525C29.0767 25.0525 26.7107 27.4733 26.7107 30.4487C26.7107 33.424 29.0767 35.8448 32.0061 35.8448C34.9355 35.8448 37.3015 33.424 37.3015 30.4487C37.3015 27.4733 34.9355 25.0525 32.0061 25.0525Z"
          fill="black"
          stroke="black"
          strokeWidth="0.516129"
        />
        <path
          id="Vector_12"
          d="M23.3657 38.8955L23.3657 38.8955C22.7614 39.223 22.3865 39.8621 22.3865 40.5549V44.1486C22.3865 45.2322 23.249 46.1194 24.3237 46.1194H39.6756C40.7503 46.1194 41.6128 45.2322 41.6128 44.1486V40.5549C41.6128 39.8621 41.2378 39.223 40.6335 38.8955C35.2353 35.9694 28.764 35.9694 23.3657 38.8955ZM24.3419 44.1352V40.616C29.1351 38.0415 34.8642 38.0415 39.6574 40.6161V44.1352H24.3419Z"
          fill="black"
          stroke="black"
          strokeWidth="0.516129"
        />
      </g>
    </svg>
  );
};

export default ClipboardColoredIcon;
